import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { Fish, Layers, BookOpen, Film } from 'lucide-react';

const LINKS = [
    { to: '/species', label: 'Catálogo', icon: Fish, end: true },
    { to: '/species/cromos-album', label: 'Álbum Cromos', icon: Layers, end: false },
] as const;

export function SpeciesSubNav() {
    return (
        <nav className="flex gap-1 p-1 bg-muted/50 rounded-lg w-fit flex-wrap">
            {LINKS.map(({ to, label, icon: Icon, end }) => (
                <NavLink
                    key={to}
                    to={to}
                    end={end}
                    className={({ isActive }) =>
                        cn(
                            'flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium transition-colors',
                            isActive
                                ? 'bg-primary text-primary-foreground'
                                : 'text-muted-foreground hover:text-foreground'
                        )
                    }
                >
                    <Icon size={14} />
                    {label}
                </NavLink>
            ))}
        </nav>
    );
}

export function SpeciesDetailTabBar({
    activeTab,
    onChange,
    showAppTab,
}: {
    activeTab: 'catalog' | 'details' | 'app' | 'video';
    onChange: (tab: 'catalog' | 'details' | 'app' | 'video') => void;
    showAppTab: boolean;
}) {
    const tabs: { id: 'catalog' | 'details' | 'app' | 'video'; label: string; icon: typeof Fish }[] = [
        { id: 'catalog', label: 'Catálogo', icon: Fish },
        { id: 'details', label: 'Ficha', icon: BookOpen },
        { id: 'video', label: 'Vídeo', icon: Film },
    ];
    if (showAppTab) {
        tabs.push({ id: 'app', label: 'App y relaciones', icon: Layers });
    }

    return (
        <div className="flex gap-1 p-1 bg-muted/50 rounded-lg w-fit flex-wrap">
            {tabs.map(({ id, label, icon: Icon }) => (
                <button
                    key={id}
                    type="button"
                    onClick={() => onChange(id)}
                    className={cn(
                        'flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium transition-colors',
                        activeTab === id
                            ? 'bg-primary text-primary-foreground'
                            : 'text-muted-foreground hover:text-foreground'
                    )}
                >
                    <Icon size={14} />
                    {label}
                </button>
            ))}
        </div>
    );
}
